
const btnList = [
  {
    type: "home",
    class: "tabler--home",
    name: "home",
    href: "/",
  },
  {
    type: "phone",
    class: "tabler--phone",
    name: "phone",
    href: "",
  },
  {
    type: "email",
    class: "tabler--mail",
    name: "e-mail",
    href: "",
  },
  {
    type: "inquiry",
    class: "tabler--help",
    name: "inquiry",
    href: "/contact-us",
  },
];
export default {
  name: "FooterButtonGroup",
  props: ["footerData"],
  data() {
    return {
      btnList,
    };
  },
  mounted() {
    this.btnList.map(v => {
      if (v.type == "phone") {
        v.href = `tel:${this.footerData.visitthird.phoneNumber}`;
      } else if (v.type == "email") {
        v.href = `mailto:${this.footerData.visitthird.email}`;
      }
      return v;
    });
  },
};
